import { ApiResponse } from '../../types';

const apiUrl: string = import.meta.env.VITE_ADMIN_URL;

export const guardarCapacitacion = (token: string, body: any): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...body })
    };

    fetch(
      apiUrl + "/capacitacion/guardar",
      requestOptions
    )
      .then((res) => res.json())
      .then((data: ApiResponse) => {
        resolve(data);
      })
      .catch((err) => {
        console.error("Error al guardar capacitación: ", err);
        reject(err);
      });
  });
};

export const actualizarStatus = (token: string, body: any): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...body })
    };

    fetch(
      apiUrl + "/capacitacion/actualizar",
      requestOptions
    )
      .then((res) => res.json())
      .then((data: ApiResponse) => {
        resolve(data);
      })
      .catch((err) => {
        console.error("Error al actualizar status en capacitación: ", err);
        reject(err);
      });
  });
};
